import * as THREE from 'three';
import { Config } from '../core/Config';

export class Renderer {
  private renderer: THREE.WebGLRenderer;
  
  constructor() {
    // Create and configure the renderer
    this.renderer = new THREE.WebGLRenderer({ antialias: true });
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setClearColor(Config.CLEAR_COLOR);
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    
    // Add the canvas to the DOM
    document.body.appendChild(this.renderer.domElement);
    
    console.log('Renderer initialized');
  }
  
  public render(scene: THREE.Scene, camera: THREE.Camera): void {
    this.renderer.render(scene, camera);
  }
  
  public onResize(width: number, height: number): void {
    this.renderer.setSize(width, height);
  }
  
  public getRenderer(): THREE.WebGLRenderer {
    return this.renderer;
  }
}
